var NAMESPACE = 'td';

var Media = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "td-media", class: _vm.align && 'is-' + _vm.align }, [_c('div', { staticClass: "td-media__object" }, [_vm._t("media")], 2), _vm._v(" "), _c('div', { staticClass: "td-media__content" }, [_vm._t("default")], 2)]);
  }, staticRenderFns: [],
  name: NAMESPACE + '-media',

  props: {
    align: String
  }
};

Media.install = function (Vue) {
  Vue.component(Media.name, Media);
};

export default Media;
